import React, {Fragment} from "react";
import {View, Text, Image} from "@react-pdf/renderer";
import PropTypes from "prop-types";

import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {getCartItemName} from "./printDocumentFunctions";

const PrintDocumentBodyWizardItem = (props) => {

  const {styles, wizardGroup, selectedFeature, fabricatorData, printContext, locale, cartItemsThumbnails} = props;

  const baseInfo = (
    <View wrap={false}>
      <Text style={styles.cartItemName}>
        {selectedFeature
          ? getCartItemName(selectedFeature, fabricatorData, printContext, locale)
          : wizardGroup.productCartTitle || wizardGroup.title || wizardGroup.groupName}
      </Text>
      <View style={styles.cartItemInfo}>
        <Text style={styles.wizardItemDescription}>
          {wizardGroup.productCartDescription || ""}
        </Text>
      </View>
    </View>
  )

  const withThumbnail = fabricatorData.settings.showCartItemThumbnailsInReceipt && cartItemsThumbnails
    && cartItemsThumbnails[wizardGroup.id];

  return (
    <View wrap={!withThumbnail}>
      <Text style={styles.subPartTitle}>
        {wizardGroup.title || wizardGroup.groupName}
      </Text>
      <View style={withThumbnail ? [styles.cartItem, styles.cartItemWithThumbnail] : styles.cartItem} wrap={false}>
        {withThumbnail ? (
          <Fragment>
            <View style={styles.cartItemThumbnail} wrap={false}>
              <Image style={styles.cartItemThumbnailImage} wrap={false} source={{
                uri: cartItemsThumbnails[wizardGroup.id], method: "GET", headers: { "Cache-Control": "no-cache" }
              }} />
            </View>
            <View style={styles.cartItemWithThumbnailBody} wrap={false}>
              {baseInfo}
            </View>
          </Fragment>
        ) : baseInfo}
      </View>
    </View>
  )
};

PrintDocumentBodyWizardItem.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  // locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBodyWizardItem
